import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconWifiOff(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.451 11.394a.664.664 0 0 1-.517-.11 3.339 3.339 0 0 0-3.862 0 .666.666 0 0 1-.772-1.086 4.67 4.67 0 0 1 3.11-.844L6.554 7.498A6.639 6.639 0 0 0 3.76 8.879a.667.667 0 0 1-.855-1.023 7.982 7.982 0 0 1 2.569-1.438l-1.55-1.55A9.916 9.916 0 0 0 1.387 6.5a.67.67 0 0 1-.941-.058.666.666 0 0 1 .058-.941 11.225 11.225 0 0 1 2.419-1.633L.194 1.139a.666.666 0 1 1 .943-.943l3.4 3.4.029.029L7.19 6.249a.648.648 0 0 1 .117.117l8.497 8.497a.666.666 0 1 1-.942.943zm2.215-2.361a.668.668 0 0 1-.431-.158 6.662 6.662 0 0 0-1.381-.903.667.667 0 0 1 .584-1.198c.595.29 1.153.655 1.659 1.083a.666.666 0 0 1-.431 1.175zm2.388-2.366a.662.662 0 0 1-.441-.167 10.062 10.062 0 0 0-7.419-2.469c-.365.033-.688-.243-.718-.611s.244-.689.611-.718A11.396 11.396 0 0 1 15.494 5.5a.665.665 0 0 1-.441 1.166zM8 14a.66.66 0 0 1-.473-.193c-.06-.067-.107-.14-.14-.22s-.053-.167-.053-.253a.7.7 0 0 1 .193-.473.673.673 0 0 1 .607-.18c.04.007.08.02.12.04a.48.48 0 0 1 .12.06c.033.02.067.053.1.08a.7.7 0 0 1 .193.473c0 .087-.02.173-.053.253s-.08.153-.14.22a.662.662 0 0 1-.473.193z"
  }));
}
IconWifiOff.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconWifiOff.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconWifiOff as default };
